// src/lib/data-migration.js — migration de schéma fbz8-data.
//
// Convertit l'ancien format mono-réservation par mois/logement (cabrut,
// nuits, menage, taxe, notes top-level) en nouveau format multi-réservations
// (reservations:[{...}], extras:[]). Idempotent.
//
// Appelé une seule fois au load des données dans App.jsx (~useEffect chargement).
// Tout changement de shape `data` futur doit passer par ici, pas par un script
// one-shot (cf. CLAUDE.md "migrateData existante").

import { uid } from './format'

export function migrateData(d) {
  const nd = JSON.parse(JSON.stringify(d))
  Object.keys(nd).forEach(mk => {
    // Skip TOUS les namespaces globaux racine préfixés `_` (pas des mois) :
    // `_tombstones` (fix iCal 2026-05-23), `_monthOverrides` (Lot 3 déplacement
    // V2), et tout futur namespace. Un mois est toujours 'YYYY-MM' (jamais `_…`).
    // SANS ce skip, le `nd[mk][lid] = {reservations:[],extras:[]}` ci-dessous
    // ÉCRASE le contenu du namespace au load (bug Lot 3 attrapé en Playwright).
    if (mk.startsWith('_')) return
    Object.keys(nd[mk]).forEach(lid => {
      const e = nd[mk][lid]
      if (!e) return
      if (e.cabrut !== undefined && !e.reservations) {
        nd[mk][lid] = {
          reservations: (e.cabrut > 0 || e.menage > 0) ? [{
            id: uid(), voyageur: "Import (ancien format)", plateforme: "airbnb",
            nuits: e.nuits || 0, montant: e.cabrut || 0, menage: e.menage || 0,
            taxe: e.taxe || 0, notes: e.notes || "",
          }] : [],
          extras: [],
        }
      }
      if (!nd[mk][lid].reservations) nd[mk][lid] = { reservations: [], extras: [] }
      if (!nd[mk][lid].extras) nd[mk][lid].extras = []
    })
  })
  return nd
}
